import React from 'react';
import Proptypes from 'prop-types';
import { formatNumber } from '../../helpers/formatting';
import { Amount, Container, Evolution, Label, SideWrapper } from './elements';
/**
 *
 * @return {jsx}
 */

var Item = function Item(_ref) {
  var amount = _ref.amount,
      children = _ref.children,
      className = _ref.className,
      evolution = _ref.evolution,
      locale = _ref.locale;
  return /*#__PURE__*/React.createElement(Container, {
    className: className
  }, /*#__PURE__*/React.createElement(Label, null, children), /*#__PURE__*/React.createElement(SideWrapper, null, /*#__PURE__*/React.createElement(Amount, null, amount), evolution !== null && /*#__PURE__*/React.createElement(Evolution, {
    evolution: evolution
  }, evolution === 0 ? '=' : evolution > 0 && '+', evolution !== 0 && formatNumber({
    locale: locale,
    number: evolution,
    percent: true
  }))));
};

var node = Proptypes.node,
    number = Proptypes.number,
    string = Proptypes.string;
Item.propTypes = {
  /** First side value displayed at the right side of the container */
  amount: node,

  /** Main value of the item, like a label for example, displayed at the left side of the container */
  children: node.isRequired,

  /** Second side value displayed below the first side node. Can add extra information  */
  evolution: number,

  /** Locale code used to properly format numbers  */
  locale: string
};
Item.defaultProps = {
  amount: null,
  evolution: null,
  locale: 'en'
};
export default Item;